var exports = {
  "az": "Box__R3qIOY",
  "m4": "Octicon__Ax4Exl",
  "DZ": "Heading__cYvq9z",
};

module.exports = exports;
